import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';

import { FormData } from '@fry/lib/forms';

import { NotifyService } from '@fry/lib/utils';
import { CanComponentDeactivate } from '@fry/components/common/form';
import { BookingTypeEditForm } from '@fry/booking/lib/booking-types/booking-type-edit.form';
import { BookingType, BookingTypesStore } from '@fry/booking/lib';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'eas-booking-create-edit',
    templateUrl: './booking-type-create.component.html',
    providers: [
        BookingTypeEditForm
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BookingTypeCreateComponent implements OnInit, CanComponentDeactivate {

  public bookingType!: BookingType;
  public formData$!: Observable<FormData>;

  constructor(
    private bookings: BookingTypesStore,
    private editForm: BookingTypeEditForm,
    private notify: NotifyService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.bookingType = this.bookings.blank();
    this.formData$ = this.editForm.init(this.bookingType);
  }

  onSubmit() {
    this.editForm.submit(this.bookingType).subscribe(
      data => {
        this.bookingType = data;
        this.notify.success($localize `New booking type successfully created`);
        this.router.navigate(['../'], { relativeTo: this.route });
      },
      error => this.notify.error(error)
    );
  }

  canSafelyDeactivate() {
    return this.editForm.pristine;
  }

}
